import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';
import { ContactType, ServiceTeamWithDetails } from '../generated';

const LazyServiceTeamDrawer = React.lazy(() => import('../components/ServiceTeamDrawer'));

export const ServiceTeamDrawer: React.FC<
	OverlayDrawerComponentProps<'urn:sfdrawer:client-mgt-pilet:service-team:manage'>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	// TODO: This is a workaround for an issue where enum values not being passed correctly
	// Remove once fixed https://issues.sharefile-coretools.com/browse/SFCL-15
	let serviceTeamToEdit: ServiceTeamWithDetails | undefined = undefined;
	if (options?.serviceTeamToEdit) {
		serviceTeamToEdit = structuredClone(options.serviceTeamToEdit);
		for (const member of serviceTeamToEdit?.members ?? []) {
			if (member.contactType.toString() === 'Primary') {
				member.contactType = ContactType.Primary;
				if (member.contactType.toString() === 'Unknown') {
					member.contactType = ContactType.Unknown;
				}
			}
		}
	}

	return (
		<React.Suspense fallback={<div data-testid="loading-service-team-drawer" />}>
			<LazyServiceTeamDrawer
				initialParameters={{
					piral,
					cancelInteraction,
					completeInteraction,
					serviceTeamToEdit,
				}}
			/>
		</React.Suspense>
	);
};
